import React from 'react';
import cn from 'classnames';
import style from './input.mod.scss';

const Input = ({ type, name, label, placeholder, value, onChange, error }) => {
  const classes = cn(style.input, {
    [style[`input--error`]]: error,
  });

  return (
    <div className={classes}>
      {/* <label htmlFor={name}>{label}</label> */}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
export default Input;
